module.exports = __webpack_public_path__ + "static/media/Krombacher-SansRegular.ae5675b4.otf";